<template>
  <!-- Columns with Duplicates attachments -->

  <div class="table-fields">
    <div class="tr">
      <div class="td w-40">
        <i class="fa fa-times" v-if="attachmentsHasErrors(attachmentsObject)"></i>

        <i class="fa fa-check-square-o"
           v-else-if="attachmentsListIsResolved(attachmentsObject) || attachmentsListIsEmpty(attachmentsObject)"></i>

        <div class="form-check form-check-inline mr-0" v-else>
          <input type="checkbox" class="form-check-input" :value="id"
                 @change="$emit('selected-attachments-change', id, isSelectedAttachments)"
                 v-model="isSelectedAttachments">
        </div>
      </div>
      <div class="td">
        <div class="table-fields" v-if="!attachmentsListIsEmpty(attachmentsObject)">
          <template v-for="(attachments, type) in attachmentsObject">
            <div class="tr-header">
              <div class="td"><b>{{ type }}</b></div>
            </div>
            <div class="tr" v-for="attachment in attachments">
              <div class="td">
                <a :href="attachment['link']" target="_blank">{{ attachment['name'] }}</a>
                <i v-if="!attachment['valid']" class="fa fa-exclamation-triangle text-danger"
                   data-toggle="tooltip" data-placement="top" data-boundary="window"
                   :id="'tt' + attachment['id']" :data-container="'#tt' + attachment['id']"
                   title="This document appears to be corrupt or empty"></i>
                <br/>
                <small>Size: {{ bytesFormatted(attachment['size']) }}</small>
                <small class="text-danger" v-if="attachment['error']">{{ attachment['error'] }}</small>
              </div>
            </div>
          </template>
        </div>
        <div v-else>
          No attachments
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import ApplicationsMerge from "../../mixins/ApplicationsMerge";

export default {
  mixins: [ApplicationsMerge],

  emits: [
    'selected-attachments-change'
  ],

  props: {
    id: {
      type: Number,
      required: true,
    },

    attachmentsObject: {
      type: Object,
      required: true,
    },

    applicationAttachments: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      isSelectedAttachments: false,
    };
  },

  methods: {

    // Determine if attachment list equals to original application attachments.
    attachmentsListIsResolved(attachments) {

      let originalFileTypes = Object.keys(this.applicationAttachments);
      let duplicateFileTypes = Object.keys(attachments);

      if (originalFileTypes.length !== duplicateFileTypes.length)
        return false;
      else if (originalFileTypes.length === 0)
        return true;  // If both target and duplicate are empty, then attachments list considered as resolved.

      return Object.keys(this.applicationAttachments).map(fileType => {
        let appFileTypeHash = this.hashTable(this.applicationAttachments[fileType], ['name', 'size']);

        if (!attachments[fileType]) return false;

        let dupFileTypeHash = this.hashTable(attachments[fileType], ['name', 'size']);

        return appFileTypeHash === dupFileTypeHash;
      }).reduce((total, item) => total & item, true);
    },

    attachmentsHasErrors(attachments) {

      return Object.keys(attachments).map(fileType => {
        return attachments[fileType].map(file => !!file.error).reduce((result, item) => result | item, false);
      }).reduce((result, item) => result | item, false);
    },

  },

}
</script>

<style scoped>

.w-40 {
  width: 40px;
}

.table-fields {
  display: table;
  width: 100%;
}

.tr-header {
  display: table-row;
  font-weight: bold;
}

.tr {
  display: table-row;
}

.td {
  display: table-cell;
  padding: 5px;
}

del, ins {
  padding: 2px 5px;
  border-radius: 5px;
}

</style>
